var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLocationLogo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16.5,
    cy: 16.5,
    r: 16.5,
    fill: "#FBA63C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 16.5C16.9125 16.5 17.2657 16.353 17.5598 16.059C17.8538 15.765 18.0005 15.412 18 15C18 14.5875 17.853 14.2343 17.559 13.9402C17.265 13.6462 16.912 13.4995 16.5 13.5C16.0875 13.5 15.7343 13.647 15.4402 13.941C15.1462 14.235 14.9995 14.588 15 15C15 15.4125 15.147 15.7657 15.441 16.0598C15.735 16.3538 16.088 16.5005 16.5 16.5ZM16.5 24C14.4875 22.2875 12.9845 20.697 11.991 19.2285C10.9975 17.76 10.5005 16.4005 10.5 15.15C10.5 13.275 11.1033 11.7812 12.3098 10.6687C13.5163 9.55625 14.913 9 16.5 9C18.0875 9 19.4845 9.55625 20.691 10.6687C21.8975 11.7812 22.5005 13.275 22.5 15.15C22.5 16.4 22.003 17.7595 21.009 19.2285C20.015 20.6975 18.512 22.288 16.5 24Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationLogo);
export default __webpack_public_path__ + "static/media/locationLogo.4b30861c2b7ca7a8849e4acbb433f0d8.svg";
export { ForwardRef as ReactComponent };